module.exports = __webpack_public_path__ + "img/taxi.7efd6c4f.png";